<div
  class="product-list"
  [orderformBreakpoint]="{ '400': 'view-small' }"
  *ngIf="productListSettings$ | async as productListSettings"
>
  <ng-container
    *ngFor="
      let product of onlyActiveProductList$ | async;
      trackBy: trackByProductId;
      let index = index;
      let l = last
    "
  >
    <div class="d-flex product-list-item">
      <div class="w-100">
        <div class="d-flex w-100 align-items-center">
          <div class="product-image-box">
            <div class="product-image-container">
              <img
                class="product-image"
                alt="Product image"
                [src]="product.image_url"
              />
            </div>
          </div>
          <div class="w-100">
            <strong>
              {{ product.orderItem.quantity.value }}x {{ product.headline }}
            </strong>
            <div class="delivery_desc">
              {{ product.service_description }}
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="d-flex justify-content-end">
          <div class="price-col">
            <orderform-product-price
              [product]="product"
              [withoutInterval]="productListSettings.have_plain_price_view"
              [showDiscount]="showDiscountOnItem$ | async"
              display="total_amounts"
              displayDiscount="total_amounts_undiscounted"
            ></orderform-product-price>

            <small
              class="d-block"
              *ngIf="productListSettings.have_plain_price_view"
            >
              *
              <ng-container i18n="@@order_summary.vat_included"
                >Einschließlich Mehrwertsteuer</ng-container
              >
            </small>
          </div>
        </div>
      </div>
    </div>

    <div class="divider"></div>
  </ng-container>
</div>
